import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import moment from "moment";
import { toast } from "react-toastify";

const DataViewPermesisonForm = (props) => {
  const frmRef = useRef({});
  const [backImage, setBackImage] = useState(
    "https://img.freepik.com/premium-vector/anonymous-user-circle-icon-vector-illustration-flat-style-with-long-shadow_520826-1931.jpg?w=1060"
  );

  const [empData, setEmpData] = useState();
  const [empId, setEmpId] = useState();
  const [reportingEmployeeData, setReportingEmployeeData] = useState([]);
  const { sendRequest: getUser } = useHttp();

  const employeeData = () => {
    getUser(
      {
        url: `/api/employee/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          setEmpData(res.output);
        }
      }
    );
  };

  useEffect(() => {
    employeeData();
  }, [getUser]);

  const handleEmpChange = (e) => {
    const id = e.target.value;
    setEmpId(id);

    const filteredEmp =
      empData &&
      empData.filter((item) => parseInt(item.empId) === parseInt(id));

    if (filteredEmp && filteredEmp?.length > 0) {
      FillreportingEmployee(filteredEmp[0].empId);

      frmRef.current.employee_code.value = filteredEmp[0].employeeCode ?? "";
      frmRef.current.designation.value = filteredEmp[0].designationName;
      frmRef.current.department.value = filteredEmp[0].departmentName;
      setBackImage(
        `${process.env.REACT_APP_FILE_URL}${
          filteredEmp && filteredEmp[0].profileurl
        }`
      );
    } else {
      frmRef.current.employee_code.value = "";
      frmRef.current.designation.value = "";
      frmRef.current.department.value = "";
    }
  };

  const { sendRequest: getreportingEmployee } = useHttp();

  const FillreportingEmployee = (employeeId) => {
    getreportingEmployee(
      {
        url: `/api/getreportingEmployee/?employeeId=${employeeId}&&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (res) => {
        if (res) {
          setReportingEmployeeData(res);
        }
      }
    );
  };

  const handleSubServiceCheckChange = (e, empId) => {
    const isChecked = e.target.checked;

    const updatedReportingEmployeeData = reportingEmployeeData?.map((row) =>
      row.empId === empId ? { ...row, isAllocated: isChecked } : row
    );

    setReportingEmployeeData(updatedReportingEmployeeData);
  };

  const handleBulkSelect = (e) => {
    const isChecked = e.target.checked;

    const updatedReportingEmployeeData = reportingEmployeeData?.map((row) => ({
      ...row,
      isAllocated: isChecked,
    }));

    setReportingEmployeeData(updatedReportingEmployeeData);
  };

  const { sendRequest: postRoles } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    const UserIdList = [];
    const EmployeeIdList = [];

    reportingEmployeeData.forEach((item) => {
      if (item.isAllocated) {
        EmployeeIdList.push(item.empId);
        UserIdList.push(item.userId);
      }
    });

    const data = {
      employeeId: empId,
      reportingEmployeeIdList: EmployeeIdList,
      reportingUserIdList: UserIdList,
      orgId: parseInt(localStorage.getItem("orgId")),
      createdBy: parseInt(localStorage.getItem("id")),
      createdDate: moment(new Date().toISOString().slice(0, 10)).format(
        "DD/MM/YYYY"
      ),
    };

    console.log(data);

    postRoles(
      {
        url: "/api/dataview/",
        method: "POST",
        body: data,
      },
      () => {
        props.addForm(false);

        toast.success("Data sharing and permissions updated");
      }
    );
  };
  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="card card-default">
              <form onSubmit={submitHandler}>
                <div className="card-header">
                  <h3 className="card-title">Data View Permissions Form </h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>

                <div className="card-body">
                  <div className="row">
                    <div className="col-md-3 text-center">
                      <div className="form-group mt-5">
                        <img
                          src={`${backImage}`}
                          className="user-image img-circle"
                          width="160"
                          height="160"
                          alt="User Image"
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Employee Name</label>
                        <select
                          className="form-control"
                          style={{ width: "100%" }}
                          ref={(el) => (frmRef.current["employee_name"] = el)}
                          onChange={handleEmpChange}
                          required
                        >
                          <option value="">Select</option>
                          {empData &&
                            empData?.map((x) => (
                              <option
                                key={x.empId}
                                value={x.empId}
                                // selected={
                                //   props.update && x.empId === props.update.empId
                                // }
                              >
                                {x.employeeName+"("+x.employeeCode+")"}
                              </option>
                            ))}{" "}
                        </select>
                      </div>

                      <div className="form-group">
                        <label>Designation</label>
                        <input
                          type="text"
                          className="form-control"
                          style={{ width: "100%" }}
                          readOnly
                          ref={(el) => (frmRef.current["designation"] = el)}
                        />
                      </div>
                    </div>
                    {/* /.col */}
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Employee Code</label>
                        <input
                          ref={(el) => (frmRef.current["employee_code"] = el)}
                          readOnly
                          type="text"
                          className="form-control"
                          style={{ width: "100%" }}
                        />
                      </div>

                      <div className="form-group">
                        <label>Department</label>
                        <input
                          type="text"
                          className="form-control"
                          style={{ width: "100%" }}
                          ref={(el) => (frmRef.current["department"] = el)}
                          readOnly
                        />
                      </div>
                    </div>
                  </div>


                  <div className="row">
                    <div className="col-md-1"></div>
                    <div className="col-md-11">
                      <table className="table table-bordered text-center table-sm">
                        <thead>
                          <tr>
                            <th className="text-center">
                              <input
                                type="checkbox"
                                onChange={handleBulkSelect}
                                checked={
                                  reportingEmployeeData?.length > 0 &&
                                  reportingEmployeeData.every(
                                    (row) => row.isAllocated
                                  )
                                }
                              />{" "}
                              Check
                            </th>
                            <th>Employee Name</th>
                            <th>Employee Code</th>
                            <th>Level</th>
                            <th>Department Name</th>
                            <th>Designation Name</th>
                          </tr>
                        </thead>

                        <tbody>
                          {reportingEmployeeData?.map((itm, i) => (
                            <tr key={i}>
                              <td>
                                <input
                                  type="checkbox"
                                  checked={itm.isAllocated}
                                  onChange={(e) =>
                                    handleSubServiceCheckChange(e, itm.empId)
                                  }
                                />
                              </td>
                              <td>{itm.employeeName}</td>
                              <td>{itm.employeeCode}</td>
                              <td>Level {itm.level}</td>
                              <td>{itm.departmentName}</td>
                              <td>{itm.designationName}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <hr />

                  <div className=" text-right">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default DataViewPermesisonForm;
